import { useTranslation } from "react-i18next"
import { DossierDto, DossierStatus, IDossierApiClient } from "../clients/dossierApiClient"
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { useRef } from "react";
import React from "react";
import { UpdateDossierStatus } from "../clients/dossierApiClient";
import { Alert, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { LoadButton } from "./loadButton";
import { useInjection } from "../di/ioc-provider";
import { TYPES } from "../di/types";

export interface UpdateDossierStatusProps {
    dossier: DossierDto
    onCancel : () => void;
}

export const UpdateDossierStatusForm = (dto: UpdateDossierStatusProps) => {

    const [t] = useTranslation("common");
    const formRef = useRef(null);
    const [saving,setSaving] = React.useState(false);
    const _dossierClient = useInjection<IDossierApiClient>(TYPES.IDossierClient);
    const [success,setSuccess] = React.useState(false);
    const [error,setError]  =React.useState(false);
    const [formModel, setFormModel] = React.useState<UpdateDossierStatus>({
        dossierId : dto.dossier.id,
        dossierStatus : dto.dossier.status
    })

    const saveDossierStatus = () => {
        setSaving(true);
        _dossierClient.updateDossierStatus(formModel).takeAtLeast(1000).then((res) => {
            setSuccess(true);
            setTimeout(() => {dto.onCancel();},1500)
        }).catch(() => {
            setError(true);
        }).finally(() => {
            setSaving(false);
        })
    }

    const saveValidate = () => {
        if (formRef != null && formRef.current != null) {
            var testForm = formRef.current as any;
            testForm
                .isFormValid()
                .then((result: boolean) => {
                    if (result) {
                        saveDossierStatus();
                    }
                })
                .catch((err: any) => { });
        }
    };

    return <>
        {error ? <><Alert severity="error">{t("updateDossier.error")}</Alert></> : <></>}
        {success ? <><Alert severity="success">{t("updateDossier.success")}</Alert></> : <></>}
        <Typography style={{marginBottom:"4px"}} variant="h2"> {dto.dossier.name} - {t("general.dossierNr")} {dto.dossier.id}</Typography>
       

        <ValidatorForm style={{ width: "100%" }} ref={formRef} onSubmit={() => { }}>
            <FormControl fullWidth>
                <InputLabel>{t("general.chooseState")}</InputLabel>
                <Select
                  
                    label={t("general.chooseState")}
                    disabled={saving}
                    onChange={(ev) => {
                        var model = {...formModel};
                        model.dossierStatus = parseInt(ev.target.value as string) as DossierStatus;
                        setFormModel(model);
                        // props.onTeamPicked(ev.target.value as number);
                        // var team = new List(teams).FirstOrDefault(w => w.id == ev.target.value);
                        // if (team != undefined) {
                        //     setSelectedTeam(team);
                        // }
                    }}
                    value={formModel.dossierStatus}
                >

                    <MenuItem key={0} value={0}>{t("dossierStatus.pending")}</MenuItem>
                    <MenuItem key={1} value={1}>{t("dossierStatus.send")}</MenuItem>
                    <MenuItem key={1} value={2}>{t("dossierStatus.done")}</MenuItem>
                    {/* {teams.map((el) => {
                        return <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
                    })} */}
                </Select>
                <LoadButton
                disabled={saving}
                    color={"primary"}
                    style={{ width: "100%", marginTop: "14px" }}
                    isLoading={saving}
                    type="submit"
                    variant="contained"
                    buttonText={t("general.save")}
                    onClick={saveValidate}>

                </LoadButton>
            </FormControl>
            
        </ValidatorForm>
    </>
}